import { FAQ } from "./faq";
import { Hotel } from "./hotel";
import { CustomPage } from "./custom-page";
import type { HotelServiceProviderType } from "./hotelService";

export enum MobileScreenSettingsScreenTypes {
  BEFORE_CHECKIN = "BEFORE_CHECKIN",
  DURING_STAY = "IN_HOUSE",
  AFTER_CHECKOUT = "BEFORE_CHECKOUT",
}

export interface MobileScreenSettingsShortcuts {
  id: string;
  name: string;
  link: string;
  order: number;
}

export interface MobileScreenSettingsFaq {
  id: string;
  faqId: string;
  order: number;
  faq: FAQ;
}

export interface MobileScreenSettingsLinkedService {
  name: string;
  price?: number | string | null;
  category: { name: string };
  providerType?: HotelServiceProviderType;
}

export interface MobileScreenSettingsServiceRelation {
  id: string;
  serviceId: string;
  order: number;
  service: MobileScreenSettingsLinkedService;
}

export interface MobileScreenSettingsPageRelation {
  id: string;
  customPageId: string;
  order: number;
  customPage: CustomPage;
}

export interface MobileScreenSettingsEntity {
  id: string;
  hotelId: string;
  screenType: MobileScreenSettingsScreenTypes;
  isAddressVisible: boolean;
  isChatDisplayEnabled: boolean;
  themeType?: string | null;
  appTextColor?: string | null;
  appBgColor?: string | null;
}

export interface MobileScreenSettingsWithRelations
  extends MobileScreenSettingsEntity {
  mobileScreenSettingsShortcuts: MobileScreenSettingsShortcuts[];
  mobileScreenSettingsFaqs: MobileScreenSettingsFaq[];
  mobileScreenSettingsRecommendedServices: MobileScreenSettingsServiceRelation[];
  mobileScreenSettingsFeaturedActivities: MobileScreenSettingsServiceRelation[];
  mobileScreenSettingsCtaServices: MobileScreenSettingsServiceRelation[];
  mobileScreenSettingsChatServices: MobileScreenSettingsServiceRelation[];
  mobileScreenSettingsPages: MobileScreenSettingsPageRelation[];
  hotel?: Pick<Hotel, "name" | "hotelAddress" | "logoId"> & {
    carouselPhotos: { id: string; photoId: string; photo: { url: string } }[];
  };
}

export interface UpdateMobileScreenSettings {
  id?: string;
  hotelId: string;
  screenType?: MobileScreenSettingsScreenTypes;
  isAddressVisible?: boolean;
  shortcuts?: string[];
  faqIds?: string[];
  carouselPhotoIds?: string[];
  recommendedServiceIds?: string[];
  featuredServiceIds?: string[];
  ctaServiceIds?: string[];
  chatServiceIds?: string[];
  isChatDisplayEnabled?: boolean;
  pageIds?: string[];
  hotelName?: string;
  logoId?: string;
  themeType?: string | null;
  appTextColor?: string | null;
  appBgColor?: string | null;
}
